import { sportClubBoardModel } from '@/models/api/sportClubBoard.model';
import { sportClubSportTypeModel } from '@/models/api/sportClubSportType.model';

export const sportClubModel = (data = {}) => ({
    uuid: data.uuid,
    name: data.name || '',
    isActive: Number(data.is_active),
    createdAt: data.created_at || null,
    createdBy: data.created_by || null,
    updatedAt: data.updated_at || null,
    updatedBy: data.updated_by || null,
    deletedAt: data.deleted_at || null,
    deletedBy: data.deleted_by || null,
    description: data.description || '',
    url: data.url || '',
    coverImage: data.cover_image || '',
    sportType: data.sport_type ? sportClubSportTypeModel(data.sport_type) : null,
    boards: (data.sport_club_board || []).map(sportClubBoardModel),
});
